import Link from 'next/link';
import {TopicPillTag} from 'iq-questions/components/topic_pilltag';
import {LevelPillTag} from 'iq-questions/components/level_pilltag';
import {DotSeparator} from 'common/components/dot_separator';
import type {QuestionFeedItem} from 'iq-companies/types';

// "New question added" card — ported from the dashboard feed's QuestionFeedCard. Not tied to
// any company (see feed_area.tsx's filter scoping).
export function QuestionFeedCard({item}: {item: QuestionFeedItem}) {
  return (
    <Link
      href={`/questions/${item.question_slug}`}
      className='block rounded-xl border border-gray-200 bg-white p-5'>
      <div className='flex flex-wrap items-center gap-2 text-xs'>
        <span className='font-semibold uppercase tracking-wide text-iq-orange'>New Question</span>
        <DotSeparator className='text-gray-300' />
        <span className='text-gray-500'>just added</span>
      </div>
      <p className='mt-2 font-semibold text-gray-900'>{item.question_title}</p>
      {item.question_summary && (
        <p className='mt-1 line-clamp-2 text-sm text-gray-600'>{item.question_summary}</p>
      )}
      <div className='mt-3 flex items-center gap-2'>
        {item.question_topic && <TopicPillTag name={item.question_topic} />}
        <LevelPillTag level={item.question_level} />
      </div>
    </Link>
  );
}
